export const advantagePlanSelectType = [
    {key: 'contractNumber', value: 'Contract Number'},
    {key: 'legalEntityName', value: 'Legal Entity Name'},
    {key: 'marketingName', value: 'Marketing Name'},
    // {key: 'effectiveDate', value: 'Effective Date'},
    // {key: 'contactNumber', value: 'Contact Number'}
]

export const documentTypes = [
    {key: "1", value: "Appeals Package"},
    {key: "2", value: "A/R"},
    {key: "3", value: "Authorization"},
    {key: "4", value: "Claim Status"},
    {key: "5", value: "Copay Log"},
    {key: "6", value: "Diagnostic Ultrasound"},
    {key: "7", value: "Document Batch"},
    {key: "8", value: "Eligibility"},
    {key: "9", value: "Explanation of Benefits (EOB)"},
    {key: "10", value: "History and Physical"},
    {key: "11", value: "Insurance Correspondence"},
    {key: "12", value: "Letter of Medical Necessity"},
    {key: "13", value: "Line Document"},
    {key: "14", value: "Medical Record Request"},
    {key: "15", value: "Medical Report"},
    {key: "16", value: "Narrative Report"},
    {key: "17", value: "Operative Report"},
    {key: "18", value: "Patient Authorization/Referral"},
    {key: "19", value: "Patient Correspondence"},
    {key: "20", value: "Patient Demographics"},
    {key: "21", value: "Patient Driver's License"},
    {key: "22", value: "Patient Insurance Card"},
    {key: "23", value: "Payment Batch"},
    {key: "24", value: "Prescriptions"},
    {key: "25", value: "Superbill"},
    {key: "26", value: "Superbill Batch"},
    {key: "27", value: "Tests"},
    {key: "28", value: "Ultrasound"},
    {key: "29", value: "Other"},
]